var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirefox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 2.2c-.6.6-.8 2.1-.3 3.6.6 1.5 1.5 1.2 2 2.7.7 2 .4 4.7.4 4.7s.9 2.5 1.5-.2c1.3-5-3.6-9.6-3.6-10.8z",
    fill: "url(#paint0_radial)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.9c5.8 0 10.4-4.7 10.4-10.5C22.4 6.7 17.8 2 12 2a10.4 10.4 0 000 21z",
    fill: "url(#paint1_radial)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 18.9l-.7.4 1-1.5a5.8 5.8 0 00.8-1.2 10 10 0 001.2-4.5 8 8 0 00-.1-1.4v.1c.1 1 0 2-.4 2.8a9 9 0 000-3.5s0-.6-.8-2.4c-.4-1-1.2-2-1.8-2.6l-1.4-1.5a4 4 0 01-1-1.4L15.3 1c-.5.8-2.1 3.2-1.3 5.5.3 1 1.2 2.1 2 2.7.1 0 .6.6.8 1.8.3 1.3.2 2.3-.3 3.7-.6 1.3-2.2 2.6-3.6 2.7-3 .3-4.1-1.5-4.1-1.5 1 .4 2.3.3 3-.1.7-.5 1.2-.8 1.5-.7.4.1.7-.2.4-.6a1.8 1.8 0 00-1.8-.8c-.8 0-1.5.7-2.4 0h-.2.1l-.6-.4H9c-1-.7-.8-1.2-.8-1.5 0-.3.2-.6.5-.7h.1V11l.5.3c.2 0 .2.2.2.2v-.1s0-.2-.2-.3c.1 0 .2 0 .3.2l.1-.7v-.4-.2c0-.2 1.6-1 1.7-1l.4-.5.2-.6c0-.2 0-.3-1.6-.5-.4 0-.7-.4-.8-.6l-.1-.2v-.2c.2-.7.6-1.3 1.2-1.8 0 0-.1 0 0 0l.3-.2s-.3-.2-.6-.1l-.4.1.2-.1a3 3 0 00-1 .4v-.1c-.2 0-.5.3-.6.5V5a2 2 0 00-.4.3C7.4 5 6.6 5 6 5.1c-.1-.1-.2 0-.5-.7 0-.2 0 .1 0 0L3.8 5.6s.4 0 0 0l-.2 1-.5.9c-.3.6-.7 1.6-1.1 3l.6-1.1c-.3.8-.6 2-.7 4l.3-1.2a11 11 0 002 7 10.6 10.6 0 0015.6-.3z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20.4c3.8-.5 5.5-4.4 3.3-4.5-2 0-5.1 4.7-3.3 4.5z",
    fill: "url(#paint3_radial)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1 15.1c2.6-1.5 2-4.8 2-4.8s-1 1.2-1.8 3c-.6 1.9-1.8 2.7-.2 1.8z",
    fill: "url(#paint4_radial)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 22.3c3.6 1.2 6.8-1.7 4.8-2.7-1.7-.8-6.6 2.2-4.8 2.7z",
    fill: "url(#paint5_radial)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 16.5l.3-.7a4 4 0 00.6-1.9c.4-2 .4-2.7.2-4.2-.2-1.2-1-2.9-1.8-3.7-.8-.9-.2-.6-1-1.2l-1.6-1.7c-2.4-2-2.4-2.5-2.3-2.6l-.1-.1s-1.3 1.3-1.6 3.5c-.2 1.5.3 3 1.1 4l1.4 1.3c.6.9 1 2 1 3a5.1 5.1 0 01-6.4 5c-1.3-.2-2-.8-2.5-1.3l-.3-.5c1.2.5 2.6.4 3.4 0 .8-.5 1.3-.8 1.7-.7.4.1.7-.3.4-.7-.3-.4-1-1-2-.8-.9.2-1.6.7-2.7.2l-.2-.1h.2l-.7-.4h.1c-1-.7-.8-1.2-.8-1.5 0-.3.2-.6.5-.7h.2l.5.2c.2 0 .3.2.3.2V11l-.3-.3c.1 0 .2 0 .3.2l.2-.7v-.4c-.1 0 0 0 0 0v-.2c0-.2 1.7-.9 1.8-1l.5-.5.2-.6c0-.1 0-.2-.5-.3L10.2 7c-.5 0-.7-.3-.9-.6v-.2L9.1 6c.2-.7.7-1.3 1.4-1.7h-.1l.4-.2-.6-.2-.6.2.3-.2c-.4 0-.8.3-1.1.5v-.1c-.2 0-.6.3-.7.5v-.1a2 2 0 00-.4.3c-1-.4-1.8-.4-2.5-.2l-.8-1c0-.1 0 0 0 0-.2-.4-.3-.9-.2-1.3l-.6.7v.1s-.2.1-.2.3l-.2.2s0-.1 0 0a5.5 5.5 0 00-.5 2.4v.1l-.6.8c-.4.6-.9 1.6-1.3 3l.7-1c-.4.7-.7 2-.8 3.9l.3-1.2c0 1.3.1 2.9 1 4.7.4 1 1.5 3.2 4.3 4.9A9.4 9.4 0 009 22.6c1 .3 2.2.5 3.3.5 4 0 5.3-1.6 5.3-1.6l.1-.2c-.6.6-2.1.7-2.6.6a32.8 32.8 0 003.2-1.1v-.1l1.7-1c1.2-1 1.5-2 1.6-2.6v.3c-.4.7-1 1.1-1.8 1.4l1-1.4.5-.9z",
    fill: "url(#paint6_radial)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9 18.8c.5-.5 1-1.1 1.3-1.9.8-1.8 2.2-4.8 1.1-8-.8-2.4-2-3.8-3.4-5.1-2.4-2.2-3-3.2-3-3.8 0 0-2.7 3-1.6 6.2 1.2 3.2 3.6 3 5.2 6.4 2 3.9-1.5 8.1-4.3 9.3.2 0 6.3-1.4 6.6-4.9 0 0-.2 1-1.9 1.8z",
    fill: "url(#paint7_radial)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5c0-.2 0-.3-1.8-.5-.7 0-1-.7-1-1-.3.7-.4 1.4-.3 2.2 0 .5.4 1.1.5 1.4h.1c.3-.4 1.7-.9 1.8-1 .2 0 .7-.4.7-1z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.7s0 .1 0 0c-.2-.3-.2-.8-.2-1.2l-.6.7v.1l-.2.2-.1.3v-.1c-.6 1-.7 2.7-.6 2.6 1.1-1.2 2.5-1.5 2.5-1.5-.1-.1-.5-.4-.8-1z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17c-1.6-.8-3.5-1.8-3.4-4 0-3 2.7-2.4 2.7-2.4a1 1 0 00-.4.5c-.1.2-.3.8.3 1.4.8 1-1.8 2.2 2.3 4.7 0 0-1 0-1.5-.3z",
    fill: "url(#paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 15.5c1.2.4 2.5.3 3.4-.2.5-.3 1.2-.7 1.6-.6a3 3 0 00-1.5-.2h-.7.2-.4-.2c-2.4.3-4.4-1.2-4.4-1.2-.2.5.7 1.7 2 2.2z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9 18.8a9.6 9.6 0 003.1-8.5s.3 1.6-.5 3.3a9 9 0 00-.6-5.9c-1.4-2.8-3.6-4.3-4.4-5-1.3-1-1.8-2-1.9-2.1-.3.8-1.5 3.5 0 5.8 1.2 2.2 3.3 2.8 4.8 4.8 2.7 3.7-.5 7.6-.5 7.6z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12.6c-.8-1.8-1.9-2.5-2.9-3.4l.2.4c1 1 2.2 3.2 1.3 6.1-1.8 5.5-9 2.9-9.7 2.2.3 3.1 5.6 4.6 9 2.6 2-1.9 3.5-5 2.1-7.9z",
    fill: "url(#paint13_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.0524 .3593 -.52809 11.83552 22.1 5.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFEA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF8E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF272D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E0255A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C42482"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4 4.6) scale(22.7169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#007AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#0060E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005FE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2639AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#401E84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4A1475"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(5.8 -136.4 246.8) scale(7.66374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFEA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF272D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C42482"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(5.8 -63 243.6) scale(12.7979)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFAF0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF7A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF4E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF2C2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF1434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF0538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0039"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(5.8 -181.8 255.6) scale(11.7434)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF272D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C42482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#620700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.6 9.3) scale(18.3323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFEA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF8E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF272D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F92433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E91C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CF0E62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B5007F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.2) scale(21.6472)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFEA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF6711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 13.5,
    y1: 17.1,
    x2: 9,
    y2: 2.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000F43",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#001962",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002079",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 5,
    y1: 8.4,
    x2: 13.4,
    y2: 7.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C42482",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF272D",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF2C2C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7A1A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFB20D",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFD605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 4.2,
    y1: 6.1,
    x2: 3.2,
    y2: 2.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#891551",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C42482",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 6,
    y1: 11,
    x2: 7.9,
    y2: 13.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#891551",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF272D",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF272D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 9.7,
    y1: 15.8,
    x2: 9.9,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C42482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#C42482",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C42482",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C42482",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C42482",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C42482",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#C42482",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C42482",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 15.4,
    y1: 0.9,
    x2: 22.5,
    y2: 16.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF14F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFEE4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFD834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFC41E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFAB02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFA900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 16.8,
    y1: 10.1,
    x2: 13.4,
    y2: 19.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF8E00",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FF8E00",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FF8E00",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FF8E00",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FF8E00",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF8E00",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF8E00",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF8E00",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF8E00",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF8E00",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8E00",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/Firefox.5eef4cb877698fe201894ef98767c3e5.svg";
export { ForwardRef as ReactComponent };